// src/hooks/useLanguageSync.ts
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useTelegram } from "@/contexts/TelegramContext";

const LANGUAGE_CODE_MAP: Record<string, string> = {
  ru: "ru",
  "ru-RU": "ru",
  "ru-UA": "ru",
  be: "ru",
  kk: "ru",
  uk: "uk",
  "uk-UA": "uk",
  en: "en",
  "en-US": "en",
  "en-GB": "en",
};

const SUPPORTED_LANGUAGES = ["en", "ru", "uk"];

export const useLanguageSync = () => {
  const { i18n } = useTranslation();
  const { user, isReady } = useTelegram();

  useEffect(() => {
    if (!isReady) {
      return;
    }

    const storedLang = localStorage.getItem("i18nextLng");
    if (storedLang && SUPPORTED_LANGUAGES.includes(storedLang)) {
      console.log(
        `[useLanguageSync] User has a stored language preference: ${storedLang}. No changes made.`,
      );
      return;
    }

    const telegramLang = user?.languageCode;
    if (telegramLang) {
      const baseLang = telegramLang.split("-")[0];
      const mappedLang =
        LANGUAGE_CODE_MAP[telegramLang] || LANGUAGE_CODE_MAP[baseLang];

      if (mappedLang && mappedLang !== i18n.language) {
        console.log(
          `[useLanguageSync] Setting language from Telegram. Code: ${telegramLang}, Mapped to: ${mappedLang}`,
        );
        i18n.changeLanguage(mappedLang);
      } else {
        console.log(
          `[useLanguageSync] Telegram language (${telegramLang}) is not supported or already set. Using default.`,
        );
      }
    }
  }, [isReady, user, i18n]);
};
